import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper("#js-homeHeroSwiper", {
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      spaceBetween: 8,
    },
  },
  direction: "vertical",
  loop: true,
  slidesPerView: "auto",
  spaceBetween: 5,
  speed: 6000,
});
